/**
 * Change from `previous` to `current` in percent, rounded to a whole number.
 * Null when `previous` is 0: there is nothing to compare with.
 */
export const percentChange = (
  current: number,
  previous: number
): number | null =>
  previous === 0 ? null : Math.round(((current - previous) / previous) * 100);
